module.exports = __webpack_public_path__ + "static/media/benefit-indicators.9be5a502.svg";